<template>
  <map-component></map-component>
</template>

<script>
import MapComponent from "@/components/MapComponent";
export default {
  name: "MapPage",
  components: {MapComponent},
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>